module.exports = __webpack_public_path__ + "static/img/menu6.5976e241.png";